/** Append ?practice-done=1 so BeforeWeBeginPage shows the post-practice landing screen. */
export function returnAfterPractice(returnTo: string): string {
  const url = new URL(returnTo, window.location.origin)
  url.searchParams.set('practice-done', '1')
  return url.pathname + url.search
}
